import MultiAnalyticsModule from '../analytics';
import { formatForLog } from '../errors';
import type { GaEventObjectType } from '../../types/GaEventObjectType';
import type { ClickstreamEvent } from '@zg-rentals/analytics';

const logger = getLogger('analytics/trackEvent');

declare global {
  interface Window {
    // @ts-ignore
    dataLayer: any;
  }
}

type GtmEventObjectType = {
  name: string;
};

type AdditionalParamsType = {
  category?: string;
  action?: string;
  label?: string;
  value?: string | number;
  nonInteraction?: boolean;
  clickstreamEvent?: ClickstreamEvent;
};

export const trackGtmEvent = (eventObj: GtmEventObjectType) => {
  window.dataLayer.push({ event: eventObj.name });
};

export const trackEvent = (
  gaEventObj: GaEventObjectType,
  additionalParams: Partial<AdditionalParamsType> = {
    category: '',
    action: '',
    label: '',
    value: '',
    nonInteraction: false,
  },
) => {
  let ma;

  try {
    ma = MultiAnalyticsModule.getInstance().getMa();
    const category = additionalParams.category || gaEventObj.category;
    const action = additionalParams.action || gaEventObj.action;
    const label = additionalParams.label || gaEventObj.label;
    const value = additionalParams.value || gaEventObj.value;
    const nonInteraction = additionalParams.nonInteraction || gaEventObj.nonInteraction;
    const clickstreamEvent = additionalParams.clickstreamEvent;

    const eventObject: GaEventObjectType = {
      category,
      action,
      label,
      value,
      nonInteraction,
    };

    ma.trackEvent({ ...eventObject, ...(clickstreamEvent && { clickstreamEvent }) });
    return;
  } catch (err) {
    logger.error(formatForLog(err), `trackEvent errored out for ${JSON.stringify(gaEventObj)}`);
  }
};
